import MidiTrigger from './MidiTrigger.js';
import {setEffectParameterValues} from 'actions/index.js';
import ParameterContext from 'effects/ParameterContext.js';
import MidiEffectsChain from "effects/midi/MidiEffectsChain.js";
import ShadowEffects from './ShadowEffects.js';

export default class SubSequenceMidiEffects extends ShadowEffects(MidiEffectsChain) {
    constructor(subSequence, sequencerEngine) {
        super();
        this._subSequence = subSequence;
        this.sequencerEngine = sequencerEngine;
        this.effects = [];
        this.inputedTriggers = [];
        this.initShadowEffects();
    }

    get subSequence() {
        return this._subSequence;
    }

    linkEffectParameters() {
        [...this.effects, ...this.shadowEffects].forEach(
            effect => {
                effect.registerContext(new ParameterContext().forSubSequence(this.subSequence));
            });

        let values = {};
        for (let e of this.effects) {
            for (let p of e.getParameters()) {
                values = {
                    ... values,
                    ... p.setStore(this.sequencerEngine.store)
                };
            }
        }
        this.sequencerEngine.dispatch(
            setEffectParameterValues(values));
    }

    stop() {
        super.stop();
        this.shadowEffects.forEach(e => e.stop());
    }

    clear() {
        super.clear();
        this.shadowEffects.forEach(e => e.clear());
    }

    dispatch(x) {
        this.sequencerEngine.dispatch(x);
    }

    get state() {
        return this.sequencerEngine.state;
    }

    input(inputTrigger) {
        this.inputedTriggers.push(
            inputTrigger);
    }

    // outputs all the triggers that should be played post chain
    output(time, stepNumber, actualStepNumber) {
        let input = this.inputedTriggers;
        let effects = [... this.effects, ...this.shadowEffects];
        for (let i in effects) {
            let effect = effects[i];
            if (!effect.isEnabled()) {
                continue;
            }
            for (let j in input) {
                let trigger = input[j];
                effect.input(trigger);
            }
            input = effect.output(time, stepNumber, actualStepNumber);
        }

        return input;
    }

    getJson() {
        let json = super.getJson();
        let shadowJson = this.shadowEffects.map(e => ({
            ... e.getJson(),
            isShadowEffect: true
        }));
        return [... json, ... shadowJson];
    }

    fromJson(json) {
        let nonShadowEffects = json.filter(e => !e.isShadowEffect);
        let bulk = super.fromJson(nonShadowEffects);
        let shadowEffects = json.filter(e => e.isShadowEffect);
        for (let i in shadowEffects) {
            i = parseInt(i);
            bulk = {
                ... this.shadowEffects[i].fromJson(shadowEffects[i]),
                ... bulk
            };
        }
        return bulk;
    }

    onNewStep() {
        this.inputedTriggers = [];

        [...this.effects, ...this.shadowEffects].forEach(
            effect => effect.onNewStep());
    }

    triggerAttackPostFXEnvelopes(triggers) {}
    triggerAttackPreFXEnvelopes(time, stepData) {}
    triggerReleasePostFXEnvelopes(triggers) {}
    triggerReleasePreFXEnvelopes(time, stepData) {}
}
